import React, { useRef, useEffect, useState } from "react";
import axios from "axios";
import "./TransitChart.scss"; // reuse same css

export default function TransitChart() {
  const canvasRef = useRef(null);
  const [houses, setHouses] = useState({});
  const [ascSign, setAscSign] = useState(null);

  // Slots = anchor points (just one per house is enough now)
  const houseSlots = {
    1: [10, 50],
    2: [110, 220],
    3: [340, 300],
    4: [320, 110],
    5: [190, 230],
    6: [290, 360],
    7: [20, 290],
    8: [90, 330],
    9: [240, 200],
    10: [290, 50],
    11: [200, 90],
    12: [80, 50],
  };

  // Fetch Transit data
  useEffect(() => {
    axios
      .get("https://core-c343.onrender.com/api/transit-chart", {
        params: {
          year: 2025,
          month: 9,
          day: 18,
          hour: 16,
          minute: 42,
          timezone: "Asia/Kolkata",
        },
      })
      .then((res) => {
        const data = res.data;
        const planetaryPositions = data.planetaryPositions;

        const houseData = {};

        Object.keys(planetaryPositions).forEach((planet) => {
          const { longitude } = planetaryPositions[planet];
          const houseNum = Math.floor(longitude / 30) + 1; // 1–12
          if (!houseData[houseNum]) houseData[houseNum] = [];
          houseData[houseNum].push({ name: planet });
        });

        setHouses(houseData);

        // Assume Ascendant = house 1
        setAscSign(1);
      })
      .catch((err) => {
        console.error("Error fetching transit chart:", err);
      });
  }, []);

  // Draw chart
  useEffect(() => {
    if (!canvasRef.current || Object.keys(houses).length === 0 || !ascSign)
      return;

    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // Outer diamond
    ctx.beginPath();
    ctx.moveTo(200, 0);
    ctx.lineTo(400, 200);
    ctx.lineTo(200, 400);
    ctx.lineTo(0, 200);
    ctx.closePath();
    ctx.strokeStyle = "#e8811aff";
    ctx.lineWidth = 2;
    ctx.stroke();

    // Cross lines
    ctx.beginPath();
    ctx.moveTo(0, 0);
    ctx.lineTo(400, 400);
    ctx.moveTo(400, 0);
    ctx.lineTo(0, 400);
    ctx.stroke();

    // Planets + House numbers
    Object.keys(houseSlots).forEach((slot) => {
      const items = houses[slot] || [];
      const [baseX, baseY] = houseSlots[slot];

      // Draw planets with spacing
      items.forEach((item, idx) => {
        const offsetX = idx * 20; // spread horizontally
        const offsetY = idx * 15 + 15; // spread vertically
        ctx.fillStyle = "black";
        ctx.font = "bold 13px Arial";
        ctx.fillText(item.name, baseX + offsetX, baseY + offsetY);
      });

      // House number (just above the anchor point)
      ctx.fillStyle = "orange";
      ctx.font = "12px Arial";
      ctx.fillText(slot.toString(), baseX, baseY - 5);
    });
  }, [houses, ascSign]);

  return (
    <div className="transit-chart-container" style={{ textAlign: "center" }}>
      <h3>Transit Chart</h3>
      <canvas
        className="canvas"
        ref={canvasRef}
        width={400}
        height={400}
        style={{ border: "1px solid black" }}
      ></canvas>
    </div>
  );
}